import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { PrimeNgModule } from "@primeng";
import { MiproSharedModule } from "@mipro/mipro-shared.module";
import { DiagnosisControlComponent } from "./diagnosis-control.component";
import { BadgeModule } from "primeng/badge";
import { DiagnosisBadgeComponent } from "./diagnosis-badge.component";

@NgModule({
    declarations: [DiagnosisControlComponent, DiagnosisBadgeComponent],
    imports: [CommonModule, FormsModule, PrimeNgModule, MiproSharedModule, BadgeModule],
    exports: [DiagnosisControlComponent, DiagnosisBadgeComponent]
})
export class DiagnosisModule {}
